import { gql } from '@apollo/client';

export const LOGIN_QUERY = gql`
mutation login($input: LoginInput!) {
    login(input: $input) {
      status
      urltag
      menuOption
      user {
        email
        role
        offices {
          urltag
          name
          is_default
        }
      }
    }
}
`;